import _, { omit } from 'lodash';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { ROUTE_PIPELINES } from 'js/constants/pathnames';
import { Field } from '@nexla/@types';
import UIUtils from 'js/lib/UIUtils';

export const handleSourceNavigation = (
  history: any,
  source: any,
  flowType: string = 'streaming',
) => {
  const { id = '', origin_node_id = '' } = source;
  if (!!id && !!origin_node_id) {
    history.replace(`${ROUTE_CONNECT}${ROUTE_PIPELINES}/${flowType}/${origin_node_id}/edit`);
  }
};

export const getMonitoringIntervalConfig = (sourceConfig: any, fields: Field[]) => {
  const configWithMissingDefaults = UIUtils.configWithMissingDefaults(sourceConfig, fields);
  const shouldRenderField = (field: Field) =>
    !UIUtils.shouldRenderField(field, configWithMissingDefaults);
  const invisibleFieldNames = fields?.filter(shouldRenderField).map((field) => field.name);
  return omit(configWithMissingDefaults, invisibleFieldNames);
};

export const getActiveItems = (templates: any[], items: any[], selectedTemplate: undefined) => {
  const template = templates?.find((t) => t.id === selectedTemplate) || templates?.[0];
  return templates && templates?.length > 1 && template
    ? items.filter((item) => template.auth_parameters.includes(item.param_id))
    : items;
};

export const getVendorEndpointField = (item: Field) => item.name === 'vendor_endpoint_id';
export const getStartCronField = (item: Field) => item.name === 'start.cron';
